// extracted by mini-css-extract-plugin
export default {"schoolNameCell":"SchoolNameCell_schoolNameCell__8Slna","schoolNameCellTooltip":"SchoolNameCell_schoolNameCellTooltip__Rrswl"};